import React from 'react';
import ReactDOM from 'react-dom';

import { AppContainer } from 'react-hot-loader';

import SubFeature from '../../universal/app/components/SubFeature';

class SubFeatureMain {
    constructor(container, params) {
        this.container = container;
        this.params = params;
    }

    mount(data) {
        const { locale, platform } = this.params;

        const render = (Component) => {
            ReactDOM.render((
                <AppContainer>
                    <Component platform={platform} locale={locale} data={data} />
                </AppContainer>
            ), this.container);
        };

        render(SubFeature);

        if (module.hot) {
            module.hot.accept('../../universal/app/components/SubFeature', () => {
                // eslint-disable-next-line global-require
                const NextAppComponent = require('../../universal/app/components/SubFeature').default;
                render(NextAppComponent);
            });
        }
    }

    unmount() {
        ReactDOM.unmountComponentAtNode(this.container);
    }
}

export default SubFeatureMain;
